var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEndpointVictim(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "61px",
    height: "61px",
    viewBox: "0 0 61.0 61.0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "i0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1680,0 L1680,1080 L0,1080 L0,0 L1680,0 Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "i1",
    x: "-59.9869287%",
    y: "-60.0196069%",
    filterUnits: "userSpaceOnUse",
    width: "180.026143%",
    height: "180.026143%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    stdDeviation: 5,
    dx: 0,
    dy: 0,
    floodColor: "rgba(2, 255, 225, 0.295726)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.9836663,0 L29.9836663,29.9836663 L0,29.9836663 L0,0 L29.9836663,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9915526,0 C15.2642165,0 15.4458836,0.181667163 15.4458836,0.454330984 L15.4458836,3.67965697 C21.306525,3.9073117 26.0765111,8.67697165 26.3035135,14.5372869 L29.5293614,14.5375478 C29.8020252,14.5375478 29.9836924,14.7194759 29.9836924,14.9918788 C29.9836924,15.2644774 29.8020252,15.4462098 29.5293614,15.4462098 L26.3037745,15.4462098 C26.076772,21.3068512 21.3067207,26.076772 15.4461445,26.3038397 L15.4461445,29.5294266 C15.4461445,29.8020252 15.2644774,29.9836924 14.9918136,29.9836924 C14.719215,29.9836924 14.5374826,29.8020252 14.5374826,29.5294266 L14.5374826,26.3038397 C8.67684119,26.0768373 3.90692031,21.3067859 3.67985267,15.4462098 L0.454265754,15.4462098 C0.181667163,15.4462098 0,15.2644774 0,14.9918788 C0,14.719215 0.181667163,14.5375478 0.454265754,14.5375478 L3.67959174,14.5375478 C3.90724647,8.67690642 8.67690642,3.90692031 14.5372217,3.6799179 L14.5372217,0.454330984 C14.5372217,0.181667163 14.718954,0 14.9915526,0 Z M25.3947863,14.5369607 L25.3790383,14.2557783 C25.0144477,9.02490467 20.7124209,4.81239056 15.4458184,4.6336542 L14.5372869,4.58831894 C9.17663789,4.81499521 4.81558228,9.17631173 4.6336542,14.5369607 L4.58831894,15.4459489 C4.81499521,20.8065979 9.17631173,25.1679144 14.5369607,25.3495815 L15.4459489,25.3949168 L25.3947863,14.5369607 Z M25.394,14.538 L15.446275,25.3945906 L15.7274576,25.3788426 C20.9583401,25.014252 25.1711015,20.7122252 25.3495815,15.4456227 L25.394,14.538 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.9836924,0 L29.9836924,29.9836924 L0,29.9836924 L0,0 L29.9836924,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7895488,0 L13.7895488,9.35341276 L9.01617066,9.35341276 L9.01617066,10.3926011 L10.0768199,10.3926011 L10.0768199,11.4318547 L3.71272888,11.4318547 L3.71272888,10.3926011 L4.7733781,10.3926011 L4.7733781,9.35341276 L0,9.35341276 L0,0 L13.7895488,0 Z M7.95526052,9.35347799 L5.83376639,9.35347799 L5.83376639,10.3927316 L7.95526052,10.3927316 L7.95526052,9.35347799 Z M12.7287038,1.03938405 L1.06077968,1.03938405 L1.06077968,8.31415917 L12.7287038,8.31415917 L12.7287038,1.03938405 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1514.0 -200.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1529.5 215.0)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#i1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.016333737038161544 0.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.0 -2.6092231683705336e-05)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i3)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,2.60922317e-05 29.9836663,2.60922317e-05 29.9836663,29.9836924 0,29.9836924 0,2.60922317e-05",
    stroke: "none",
    fill: "#55BAB0"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.016307644806444088 0.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.016307644806444088 0.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.12616463763326 10.06892697871527)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i5)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 13.7895488,0 13.7895488,11.4318547 0,11.4318547 0,0",
    stroke: "none",
    fill: "#55BAB0"
  }))))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEndpointVictim);
export default __webpack_public_path__ + "static/media/endpoint-victim.40c6b9ef47f1950ff7d4f6a6e58b121c.svg";
export { ForwardRef as ReactComponent };